import Calculator from "./pages/Calculator";
import Login from "@/pages/Login";
import OtpConfirmation from "@/pages/OtpConfirmation";
import LeasingCalculator from "@/pages/LeasingCalculator.vue";
import AgentsArea from "@/pages/AgentsArea/AgentsArea.vue";
import Home from "@/pages/AgentsArea/Home.vue";
import LocateVehicle from "@/pages/AgentsArea/LocateVehicle.vue";
import CarDetails from "@/pages/AgentsArea/CarDetails.vue";
import Summary from "@/pages/AgentsArea/CarSummary.vue";
import Thankyou from "@/pages/AgentsArea/ThankYou.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: Calculator,
  },
  {
    path: "/leasing",
    name: "leasing",
    component: LeasingCalculator,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/otp-confirmation",
    name: "otp-confirmation",
    component: OtpConfirmation,
  },
  {
    path: "/agents-area",
    component: AgentsArea,
    children: [
      {
        path: "",
        name: "agents-area",
        component: Home,
      },
      {
        path: "locate-vehicle",
        name: "locate-vehicle",
        component: LocateVehicle,
      },
      {        
        path: "car/:id",
        name: "car",
        component: CarDetails,
      },
      {
        path: "car/:id/summary",
        name: "car-summary",
        component: Summary,
      },
      {
        path: "car/:id/thankyou",
        name: "thankyou",
        component: Thankyou,
        meta: { hideTitle: true },
      },
    ],
  },
];

export default routes;
